export const LIGHT_GREY = 'rgba(37,51,103,0.3)';
export const LIGHTER_GREY = 'rgba(37,51,103,0.2)';
export const DARK_GREY = 'rgba(0, 0, 0, 0.65)';

/** @deprecated use `const {token} = theme.useToken(); const orange = token.orange` to extract colours from our theme config*/
export const AVAYLER_ORANGE = 'rgb(250,140,22)';
/** @deprecated use `const {token} = theme.useToken(); const orange = token.orange{1-10}` to extract colour variants from our theme config*/
export const AVAYLER_ORANGE_LIGHT = 'rgba(250,140,22,0.6)';
/** @deprecated use `const {token} = theme.useToken(); const orange = token.orange{1-10}` to extract colour variants from our theme config*/
export const AVAYLER_ORANGE_LIGHTER = 'rgba(250,140,22,0.2)';

/** @deprecated use `const {token} = theme.useToken(); const orange = token.orange` to extract colours from our theme config*/
export const ORANGE: React.CSSProperties = {
  color: '#D46B08',
  borderColor: '#D46B08',
  background: '#FFFEFB',
};

/** @deprecated use `const {token} = theme.useToken(); const blue = token.blue` to extract colours from our theme config*/
export const BLUE: React.CSSProperties = {
  color: '#002C8C',
  borderColor: '#002C8C',
  background: '#E6F4FF',
};

/** @deprecated use `const {token} = theme.useToken(); const green = token.success` to extract colours from our theme config*/
export const GREEN: React.CSSProperties = {
  color: '#237804',
  borderColor: '#237804',
  background: '#F6FFED',
};

/** @deprecated use `const {token} = theme.useToken(); const red = token.error` to extract colours from our theme config*/
export const RED: React.CSSProperties = {
  color: '#A8071A',
  borderColor: '#A8071A',
  background: '#FFF1F0',
};

export const BLACK: React.CSSProperties = {
  color: '#000000A6',
  borderColor: '#000000A6',
  background: '#FFFFFF',
};

export const avatarColors = ['blue', 'purple', 'green', 'red'];
